module.exports = __webpack_public_path__ + "img/invoiceRed.70a5f137.svg";